import { Checkbox, FormControlLabel } from '@mui/material';

const CheckboxUI = (props) => {
  const { label, checked, onChange, onCheckedChange, ...restProps } = props;

  const handleChange = (event, nextChecked) => {
    onChange?.(event, nextChecked);
    onCheckedChange?.(nextChecked, event);
  };

  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={handleChange} {...restProps} />}
      label={label}
      {...restProps}
    />
  );
};

export default CheckboxUI;
